let options = {
    root: null,
    rootMargin: '0px',
    threshold: 1
}
const speedomitorCallback = (elems) => {
    elems.forEach(elem => {
        if (
            !elem ||
            !elem.isIntersecting ||
            elem.intersectionRatio < options.threshold ||
            elem.target.classList.contains('animate')
        ) {
            return
        }
        elem.target.classList.add('animate');
        console.log(elem)
        setTimeout(() => {
            let counts = setInterval(updated, 15);
            let from = 170
            let to = 60;
            let upto = from;
            function updated() {
                var count = elem.target.querySelector('.milage');
                if (!count) {
                  return
                }
                if (from > to) {
                    count.innerHTML = --upto + '.' + (Math.random() * 100).toFixed(0);
                } else {
                    count.innerHTML = ++upto + '.' + (Math.random() * 100).toFixed(0);
                }

                let clear = from > to && to >= upto || from < to && upto >= to
                if (clear) {
                    clearInterval(counts);
                }
            }
        }, 1000)
    })
}
let speedomitorObserver = new IntersectionObserver(speedomitorCallback, options);
let speedomitorTarget = document.querySelectorAll('.speedomitor')
speedomitorTarget.forEach(elem => speedomitorObserver.observe(elem))

const progressCardCallback = (elems) => {
    elems.forEach(elem => {
        if (
            !elem ||
            !elem.isIntersecting ||
            elem.intersectionRatio < options.threshold ||
            elem.target.classList.contains('animate')
        ) {
            return
        }
        elem.target.classList.add('animate');
        console.log(elem)
        setTimeout(() => {
            let counts = setInterval(updated, 23);
            let from = 0
            let to = 80;
            let upto = from;
            function updated() {
                var count = elem.target.querySelector('.progressNumber');
                if (!count) {
                  return
                }
                if (from > to) {
                    count.innerHTML = --upto + '%'
                } else {
                    count.innerHTML = ++upto + '%'
                }

                let clear = from > to && to >= upto || from < to && upto >= to
                if (clear) {
                    clearInterval(counts);
                }
            }
        }, 1000)
    })
}
let progressCardObserver = new IntersectionObserver(progressCardCallback, options);
let progressCardTarget = document.querySelectorAll('.progressCard')
progressCardTarget.forEach(elem => progressCardObserver.observe(elem))


const animationCallback = (elems) => {
    elems.forEach(elem => {
        if (
            !elem ||
            !elem.isIntersecting ||
            elem.intersectionRatio < options.threshold ||
            elem.target.classList.contains('animate')
        ) {
            return
        }
        elem.target.classList.add('animate');
    })
}
let animationObserver = new IntersectionObserver(progressCardCallback, options);
let animationTarget = document.querySelectorAll('.shouldHaveAnimation')
animationTarget.forEach(elem => animationObserver.observe(elem))

$('a[href^=\\#]').on('click', function(event) {

  const href = $(this).attr('href');
  if (href !== '#') {
    $('html, body').animate({
        scrollTop: $(href).offset().top - 100
    }, 1000);
  }
  
  event.preventDefault();
  return false;
})